import React from 'react';
import { MdDeleteOutline } from 'react-icons/md';
import { Button, Modal } from '@aibuild/ui';
import type { ProcessListItemDto } from '@api/processes';
import { PUBLISHED_PROCESS_DELETE_NOTE } from './DeleteProcessDialog.constants';
import { DeleteBody, ProcessName } from './DeleteProcessDialog.styled';

export interface DeleteProcessDialogProps {
  process: ProcessListItemDto | null;
  onClose: () => void;
  onConfirm: (process: ProcessListItemDto) => void;
  isDeleting?: boolean;
  dataTestId?: string;
}

const DeleteProcessDialog: React.FC<DeleteProcessDialogProps> = ({
  process,
  onClose,
  onConfirm,
  isDeleting = false,
  dataTestId = 'delete-process-dialog',
}) => (
  <Modal
    open={process !== null}
    onClose={onClose}
    title="Delete Process"
    icon={<MdDeleteOutline />}
    size="sm"
    dataTestId={dataTestId}
    hideCloseButton={isDeleting}
    disableEscape={isDeleting}
    disableBackdropClose={isDeleting}
    footer={
      <>
        <Button
          variant="text"
          onClick={onClose}
          disabled={isDeleting}
          dataTestId={`${dataTestId}__cancel`}
        >
          Cancel
        </Button>
        <Button
          variant="filled"
          onClick={() => process && onConfirm(process)}
          disabled={isDeleting}
          dataTestId={`${dataTestId}__confirm`}
        >
          {isDeleting ? 'Deleting…' : 'Confirm'}
        </Button>
      </>
    }
  >
    <DeleteBody data-testid={`${dataTestId}__message`}>
      <p>
        <ProcessName>{process?.name}</ProcessName> will be permanently
        deleted and all its configurations will be lost.
      </p>
      {process?.status === 'published' && <p>{PUBLISHED_PROCESS_DELETE_NOTE}</p>}
      <p>Are you sure you want to proceed?</p>
    </DeleteBody>
  </Modal>
);

export default DeleteProcessDialog;
